import PropTypes from 'prop-types'
import React, { Component } from 'react'

import * as Icons from 'components/Utils/Icons'

class CommentPanelBanner extends Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    onCloseBanner: PropTypes.func.isRequired,
  }

  render() {
    const { show, onCloseBanner } = this.props
    if (!show) {
      return null
    }
    return (
      <div className="background-primary-shade-dark shade-05 padding-horizontal-large padding-vertical-normal flexbox flexbox-align-center font-weight-medium">
        <div>The thread has been resolved</div>
        <div
          className=" margin-left-auto pointer"
          onClick={onCloseBanner}
          style={{ opacity: 0.5 }}
        >
          <Icons.CloseIcon size={16} />
        </div>
      </div>
    )
  }
}

export default CommentPanelBanner
